import { apiFetch } from './client';

export interface PlaybackProfileData {
  id: string;
  scope: 'platform' | 'reseller' | 'customer';
  reseller_id: string | null;
  customer_id: string | null;
  caller_profile_id: string | null;
  auto_bookmark: boolean;
  speed_min: number;
  speed_max: number;
  speed_step: number;
  seek_short_sec: number;
  seek_long_sec: number;
  seek_xlong_sec: number;
  seek_9_sec: number;
  dtmf_mappings: Record<string, string>;
  created_at: string;
  updated_at: string;
}

export interface UpsertPlaybackProfileBody {
  auto_bookmark: boolean;
  speed_min: number;
  speed_max: number;
  speed_step: number;
  seek_short_sec: number;
  seek_long_sec: number;
  seek_xlong_sec: number;
  seek_9_sec: number;
  dtmf_mappings: Record<string, string>;
}

export const playbackProfiles = {
  get: () => apiFetch<PlaybackProfileData>('/api/settings/playback-profile'),
  put: (body: UpsertPlaybackProfileBody) =>
    apiFetch<PlaybackProfileData>('/api/settings/playback-profile', {
      method: 'PUT',
      body: JSON.stringify(body),
    }),
};
